import React from 'react';
import { Alert } from '@mui/material';

export default function ResourceUnauthorizedOrDoesNotExist() {
    return (<Alert severity={'error'}>The requested resource may be restricted to you or may not exist</Alert>);
}